module.exports = __webpack_public_path__ + "assets/static/png/up-btn.f0097685fa3aa19171690d413a0ec017.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/myPayments/images/up-btn.png
 ** module id = 523
 ** module chunks = 1
 **/